import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'
import Video from './video'

const Cover = ({ option, image, imagePlaceholder, video }) => {
  const base = 'relative top-[-3px] w-full h-[calc(100svh+5px)]'

  return (
    <div className={base}>
      {option === 'video' ? (
        <Video imagePlaceholder={imagePlaceholder} video={video} />
      ) : (
        <>
          <Image
            src={urlForImage(image.desktop).url()}
            alt={image.desktop.alt}
            fill
            placeholder="blur"
            blurDataURL={image.desktop.metadata.lqip}
            priority
            className="hidden md:block object-cover"
            quality={100}
          />
          <Image
            src={urlForImage(image.mobile).url()}
            alt={image.mobile.alt}
            fill
            placeholder="blur"
            blurDataURL={image.mobile.metadata.lqip}
            priority
            className="md:hidden object-cover"
            quality={100}
          />
        </>
      )}
    </div>
  )
}

export default Cover
